<script>
import QRCode from 'qrcode'
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      show: false,
      link: '#',
      btnText: 'Copy Link',
    }
  },

  computed: {
    ...mapState('app', {
      propertyUrl: (state) => state.currentProperty.url,
    }),
    model: {
      get() {
        return this.show
      },
      set(val) {
        if (!val) {
          this.reset()
        }
        this.show = val
        this.$emit('input', val)
      },
    },
  },

  watch: {
    value(val) {
      if (val) {
        this.showQr()
      }
    },
  },

  methods: {
    setLink() {
      const { reservationId, hotelConfirmationId, lastName } = this.item
      const bookingId = hotelConfirmationId || reservationId

      if (!bookingId) {
        this.link = '#'
      } else {
        this.link = encodeURI(
          `https://kamandaluubud.com/properties/${
            this.propertyUrl
          }/web-checkin/details?bookingId=${bookingId}&lastName=${lastName}`
        )
      }
    },
    async showQr() {
      try {
        this.setLink()
        await QRCode.toCanvas(this.$refs.qrCanvas, this.link)
        this.show = true
      } catch (err) {
        this.$store.commit('app/SET_SNACKBAR', {
          text:
            'An error was occured while generating QR Code. Please try again.',
        })
      }
    },
    copyLink() {
      navigator.clipboard.writeText(this.link)
      this.btnText = 'Link Copied'
      this.reset(3000, false)
    },
    reset(timeOut = 300, all = true) {
      setTimeout(() => {
        this.btnText = 'Copy Link'

        if (all) {
          this.setLink()
        }
      }, timeOut)
    },
  },
}
</script>

<template>
  <VDialog v-model="model" max-width="290px">
    <VCard>
      <VCardTitle class="headline">QR Code</VCardTitle>

      <VCardText class="text-xs-center">
        <canvas ref="qrCanvas"></canvas>
        <a class="d-block" :href="link" target="_blank">{{ link }}</a>
        <VBtn color="gold" flat @click="copyLink">
          {{ btnText }}
        </VBtn>
      </VCardText>

      <VCardActions>
        <VSpacer />
        <VBtn depressed dark color="gold" @click="model = false">
          OK
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>
